import { ActionIcon, Group, Paper, Stack, Text } from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";
import { formatDistanceToNow } from "date-fns";
import type { NotificationOutput } from "@/api-types";
import { useNavigator } from "@/routers/routes";
import {
  getNotificationIcon,
  renderNotificationLink,
  renderNotificationMessage,
} from "@/utils/notifications";

interface NotificationItemProps {
  notification: NotificationOutput;
  onDelete: (ids: string[]) => void;
  role: "trainer" | "owner";
}

export const NotificationItem = ({
  notification,
  onDelete,
  role: _role,
}: NotificationItemProps) => {
  const navigator = useNavigator();

  const handleNavigateToObject = () => {
    const link = renderNotificationLink({ notification });
    if (link) {
      navigator.navigate({ path: link });
    }
  };

  return (
    <Paper
      key={notification.id}
      withBorder
      p="md"
      onClick={handleNavigateToObject}
      style={{ cursor: "pointer" }}
    >
      <Group justify="space-between">
        <Group>
          {getNotificationIcon(notification.type)}
          <Stack gap={2}>
            <Text size="sm">{renderNotificationMessage(notification)}</Text>
            <Text size="xs" c="dimmed">
              {formatDistanceToNow(new Date(notification.createdAt), {
                addSuffix: true,
              })}
            </Text>
          </Stack>
        </Group>
        <ActionIcon
          variant="subtle"
          color="gray"
          onClick={(e) => {
            e.stopPropagation();
            onDelete([notification.id]);
          }}
          title="Delete notification"
        >
          <IconTrash size={16} />
        </ActionIcon>
      </Group>
    </Paper>
  );
};
